// extracted by mini-css-extract-plugin
export default {"imageWrapper":"image-dnd_imageWrapper__9J2a5","description":"image-dnd_description__9uCNX","dropzone":"image-dnd_dropzone__o7rJv","dropzoneOver":"image-dnd_dropzoneOver__yMErQ"};